<template>
	<router-link
		v-if="isAdvanced"
		:to="link"
		class="text-decoration-none d-flex align-center"
		style="width: 100%"
	>
		<slot></slot>
	</router-link>
	<a
		v-else
		@click="toggleLink(link)"
		class="text-decoration-none d-flex align-center"
		style="width: 100%"
	>
		<slot></slot>
	</a>
</template>

<script>
import linkifyThreadText from '@/mixins/linkifyThreadText'
export default {
	props: ['isAdvanced', 'link'],
	mixins: [linkifyThreadText],
	methods: {
		async toggleLink(link) {
			const target = link

			if (!target) return

			if (this.isUnsupportedDeepLink(target)) {
				this.mobileLink = true
				return
			}

			if (this.isMapUrlValid(target)) {
				try {
					await this.getMapRegisterToken()
					if (!this.mapRegisterToken) {
						console.error('Token not received')
						return
					}
					const urlWithToken = `${target}${target.includes('?') ? '&' : '?'}code=${
						this.mapRegisterToken
					}`
					window.open(urlWithToken, '_self')
				} catch (e) {
					console.error(e)
				}
			} else {
				window.open(target, '_self')
			}
		},
	},
}
</script>

<style></style>
